import { T } from "../../styles/tokens";
interface DataPoint {
  label: string;
  value: number;
}

interface TimeSeriesChartProps {
  data: DataPoint[];
  height?: number;
  color?: string;
  loading?: boolean;
  title?: string;
}

export function TimeSeriesChart({ data, height = 200, color = T.accent, loading, title }: TimeSeriesChartProps) {
  if (loading) {
    return (
      <div class="bg-white rounded-xl border border-gray-200 p-5 animate-pulse">
        {title && <div class="h-4 bg-gray-200 rounded w-32 mb-4" />}
        <div style={{ height }} class="bg-gray-100 rounded" />
      </div>
    );
  }

  if (!data.length) {
    return (
      <div class="bg-white rounded-xl border border-gray-200 p-5">
        {title && <div class="text-sm font-medium text-gray-700 mb-4">{title}</div>}
        <div style={{ height }} class="flex items-center justify-center text-gray-400 text-sm">
          Sem dados para exibir
        </div>
      </div>
    );
  }

  const max = Math.max(...data.map(d => d.value), 1);
  const barWidth = Math.max(100 / data.length, 2);

  return (
    <div class="bg-white rounded-xl border border-gray-200 p-5">
      {title && <div class="text-sm font-medium text-gray-700 mb-4">{title}</div>}
      <div style={{ height }} class="flex items-end gap-px">
        {data.map((d, i) => {
          const h = (d.value / max) * 100;
          return (
            <div
              key={i}
              class="group relative flex-1 min-w-0"
              style={{ maxWidth: `${barWidth}%` }}
            >
              <div
                class="w-full rounded-t transition-all hover:opacity-80"
                style={{ height: `${h}%`, backgroundColor: color, minHeight: d.value > 0 ? '2px' : '0' }}
              />
              <div class="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 hidden group-hover:block bg-gray-900 text-white text-xs rounded px-2 py-1 whitespace-nowrap z-10">
                {d.label}: {d.value.toLocaleString()}
              </div>
            </div>
          );
        })}
      </div>
      <div class="flex justify-between text-[10px] text-gray-400 mt-1">
        <span>{data[0]?.label}</span>
        <span>{data[data.length - 1]?.label}</span>
      </div>
    </div>
  );
}
